/**
 * ContactsAnchor JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class ContactsAnchor
 */
class ContactsAnchor {

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        this.contactsAnchor     = $( '.contact-section-anchor' );
        this.contactsSection    = $( '#contacts' );

        // The chat module (need to move contacts when the chat is active)
        this.chatModule = $( '#js-custom-chat-script' );
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        if ( this.contactsAnchor.length ) {

           $( window ).on( 'scroll', () => {
                this.checkAnchorPosition();
            });
        }
    }

    /**
     * Check the position of the conctact section and show the anchor if needed.
     */
    checkAnchorPosition() {

        if ( $( window ).scrollTop() >= this.contactsSection.offset().top - $( window ).height() ) {
            this.contactsAnchor.addClass( 'js-hidden' );
        } else {
            this.contactsAnchor.removeClass( 'js-hidden' );
        }
    }

    /**
     * Move the anchor a bit if theres a chat module active on the same site
     */
    moveAnchorPosition() {
        if ( this.chatModule.length > 0 ) {
            this.contactsAnchor.addClass( 'anchor-with-chat' );
        }
    }


    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
        this.moveAnchorPosition();
    }
}

// Export the class reference.
module.exports = ContactsAnchor;



// WEBPACK FOOTER //
// ../vaasa/assets/scripts/contacts-anchor.js